import { useTranslation } from "react-i18next";
import { Button, Modal as ModalBootstrap, Row,  } from "react-bootstrap";
import { IoIosInformationCircle } from "react-icons/io";
import { colors } from "../../../../../../theme/theme";
import { ModalContent } from "./styled";


export function ModalWarningImportProduct(props: any) {
    const { t: translation } = useTranslation();
    const { onHide, onSubmit, children, showFooter = true, submitButtonText } = props;

    return (

        <ModalBootstrap
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={'form-modal'}
        >
            <ModalContent>
                <ModalBootstrap.Header closeButton>
                    <ModalBootstrap.Title id="contained-modal-title-vcenter">
                        Aviso
                    </ModalBootstrap.Title>
                </ModalBootstrap.Header>
                <ModalBootstrap.Body style={{padding: '15px'}}>
                    <Row className="text-center text-darker-grey justify-content-center">
                        <IoIosInformationCircle className="mb-2" style={{ fontSize: '3rem', color: colors.greyscale.light_grey }} />
                        {children}
                    </Row>
                </ModalBootstrap.Body>

                {
                    showFooter ? (
                        <ModalBootstrap.Footer style={{padding: '10px 15px'}}>
                            <Button variant="outline-primary" onClick={() => onHide()}>{translation('cancel')}</Button>
                            {
                                onSubmit &&
                                <Button type="button" onClick={() => { onSubmit() }}>{submitButtonText}</Button>
                            }
                        </ModalBootstrap.Footer>
                    ) : (
                        <></>
                    )
                }
            </ModalContent>
        </ModalBootstrap>
    )
}